import React, { useState } from "react";

import SplashScreen from "../../components/loader/SplashScreen/SplashScreen";

import Cust from "./Tabs/Cust";
import Subscribe from "./Tabs/Subscribe";
import Contact from "./Tabs/Contact";
import Careers from "./Tabs/Careers";
import TestDrive from "./Tabs/TestDrive";
import Dealership from "./Tabs/Dealership";
import ReactPaginate from "react-paginate";
import { usePermissions } from "../../context/PermissionsContext";

const Customer = () => {
  const [isLoading, setisloading] = useState(false);
  const {Permissions} = usePermissions();

  return (
    <>
      {!isLoading ? (
        <div className="dashboardWrp">
          <div className="uk-container uk-container-expand">
            <div className="dashboardTop">
              <div uk-grid="" className="uk-grid">
                <div className="uk-width-1-1">
                  <div className="uk-margin ">
                    <div className="uk-flex uk-flex-between ">
                      <div>
                        <h2>Customers</h2>
                      </div>
                    </div>
                  </div>

                  <div className="analyticsContainer formCentralContainer">
                    <ul
                      className="uk-subnav uk-subnav-pill  OrdersTabs "
                      uk-switcher="connect: #analyticsTabs"
                    >
                      {/* {Ordersdata.ordersSummary.map((item) => (
                            
                            
                            
                            // <h1>{item.count}</h1>
                            <li key={item}> <a>{item._id} <h4 className="uk-text-center"> ({item.count}) </h4>  </a> </li>   
                            
                            
                            ))} */}
                      {Permissions?.includes("customers-view") && (
                      <li>
                        <a>Customers </a>
                      </li>
                      )}
                      {Permissions?.includes("subscribers-view") && (
                      <li>
                        <a>Subscribe </a>
                      </li>
                      )}
                      {Permissions?.includes("contacts-view-contacts") && (
                      <li>
                        <a>Contact </a>
                      </li>
                      )}
                      {/* <li>
                        <a>Careers </a>
                      </li> */}
                      {Permissions?.includes("test-drive-view") && (
                      <li>
                        <a>Book a Test Drive </a>
                      </li>
                      )}
                      <li>
                        <a>Dealership </a>
                      </li>
                    </ul>

                    <div className="tabContent">
                      <ul className="uk-switcher uk-margin" id="analyticsTabs">
                        {Permissions?.includes("customers-view") && (
                        <li>
                          <Cust  />
                        </li>
                        )}
                        {Permissions?.includes("subscribers-view") && (
                        <li>
                          <Subscribe   />
                        </li>
                        )}
                        {Permissions?.includes("contacts-view-contacts") && (
                        <li>
                          <Contact   />
                        </li>
                        )}
                        {Permissions?.includes("test-drive-view") && (
                        <li>
                          <TestDrive  />
                        </li>
                        )}
                        <li>
                          <Dealership  />
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <SplashScreen />
      )}
    </>
  );
};

export default Customer;
